var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',[_c('el-row',{attrs:{"gutter":_vm.model.gutter}},[_c('div',{staticClass:"drag-wrapper"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }